/** Banner zwischen Header und Inhalt (Update, Urlaubswunsch), die das feste Seitenmenü mit nach unten schieben. */
export const LAYOUT_BANNER_SELECTOR = "[data-eh-layout-banner]";

/** Unterkante des App-Headers inkl. Banner darüber (Hero/Safety) – Basis für sticky Unter-Elemente. */
export function getSiteHeaderStickyTop(headerEl?: HTMLElement | null): number {
  const el =
    headerEl ??
    document.querySelector<HTMLElement>(".eh-site-header") ??
    document.querySelector<HTMLElement>("header");
  if (el) {
    return Math.max(0, Math.ceil(el.getBoundingClientRect().bottom));
  }
  return 84;
}

/**
 * Unterkante für das feste Seitenmenü: Header, oder ein noch sichtbarer Banner
 * direkt darunter. Scrollt der Banner unter den klebenden Header, bleibt das
 * Menü an der Header-Unterkante.
 */
export function getSectionNavAnchor(headerEl?: HTMLElement | null): number {
  let anchor = getSiteHeaderStickyTop(headerEl);
  if (typeof document === "undefined") return anchor;
  for (const node of document.querySelectorAll<HTMLElement>(LAYOUT_BANNER_SELECTOR)) {
    const bottom = Math.ceil(node.getBoundingClientRect().bottom);
    if (bottom > anchor) anchor = bottom;
  }
  return anchor;
}

export function syncSiteHeaderStickyTop(headerEl?: HTMLElement | null): void {
  const topPx = getSiteHeaderStickyTop(headerEl);
  const root = document.documentElement;
  root.style.setProperty("--eh-datatable-sticky-top", `${topPx}px`);
  root.style.setProperty("--eh-site-header-bottom", `${topPx}px`);
  root.style.setProperty("--eh-section-nav-anchor", `${getSectionNavAnchor(headerEl)}px`);
}
